import { connect } from 'react-redux';
import ModuleFrame from './moduleFrame';
import { buildModuleContext, getLatestToken } from './utils';

/**
 * ModuleFrame wired to the store: supplies the user/program context and the live token, so
 * a caller only passes the module url and any extra context of its own (`extraContext`,
 * e.g. the participant whose profile the module is shown on).
 */
const mapStateToProps = (state, ownProps) => {
  const userDetail = state.UserDetail.get('userDetail');
  const currentActiveProgram = state.UserDetail.get('currentActiveProgram');
  const nodeData = state.UserDetail.get('nodeData');
  const jwtToken = userDetail && userDetail.jwtToken;
  return {
    context: {
      ...buildModuleContext({ userDetail, currentActiveProgram, jwtToken, nodeData }),
      ...ownProps.extraContext,
    },
    token: getLatestToken(jwtToken),
  };
};

export default connect(mapStateToProps)(ModuleFrame);
